<template>
  <div>
    <v-container class="dod-contract-analytics-view" style="padding-top: 60px; max-width: 1442px">
      <v-layout row wrap mt-4 align-center>        
        <v-flex xs12 sm12 md9 class="page-header-body">
          <v-flex xs12>
          <p style="color:#4a4a4a;font-size:29px;font-weight:bolder;text-justify:auto;" class="page-header">
            {{ page.header }}</p>
          </v-flex>
          <v-flex xs12 style="color:#4a4a4a;font-size:18px;font-weight:400;margin:0px;">
          <div style="margin-top:-10px;padding-top:0px;">
            <p style="text-justify:auto;line-height:22px;" class="page-header-subtext page-subtitle">
              {{ page.sub_text }}
            </p>
          </div>
        </v-flex>
        </v-flex>
      </v-layout>
      <v-layout mt-2 style="width: 100%">
        <v-card style="width: 100%">
          <v-card-text>
            <v-layout row wrap>
              <v-flex
                v-for="(analysis, index) in analysisList"
                v-if="privileges.economic_impact && privileges.economic_impact[analysis.id]"
                :key="index"
                xs12
                md3
                xl3
                pa-2>
                <router-link
                  :to="`dod-contract-analytics/${analysis.id}`"
                  exact
                  class="contract-analysis-tile-link">
                  <div
                    class="contract-analysis-tile secondary"
                    :style="{ 'backgroundImage': `url('/static/img/gdx-dod-contract-analytics-tile-${index + 1}.png')` }">
                    <span class="white--text">{{ analysis.text }}</span>
                  </div>
                </router-link>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import analysisList from '@/analysisList'
export default {
  data () {
    return {
      analysisList
    }
  },
  computed: {
    privileges () {
      return this.$store.getters.getUserPrivileges
    },
    page () {
      return this.$store.getters.getPages['dod-contract-analytics']
    }
  },
  mounted () {
    const payload = {
      meta: {
        h1: `${this.page.header}`,
        title: `${this.page.header}`,
        description: `${this.page.sub_text}`,
        keywords: '',
        requiresAuth: true
      }
    }
    document.title = payload.meta.title
    this.$store.commit('setHeaderInfo', payload)
  }
}
</script>
<style>
.contract-analysis-tile-link {
  text-decoration: none;
}
.contract-analysis-tile {
  height: 150px;
  width: 100%;
  display: flex;
  text-transform: uppercase;
  text-align: center;
  background-position: center !important;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// DoDContractAnalyticsView.vue?643ae026